var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.$userInfo.isSystemAccount
        ? _c(
            "div",
            [
              _c("app-detail-header", {
                attrs: {
                  "show-toggle": true,
                  "show-new": false,
                  "show-print": false,
                  "show-delete":
                    _vm.company &&
                    _vm.company.isActive &&
                    !_vm.isNew &&
                    _vm.$userInfo.isSystemAccount,
                  "show-save": _vm.isNew,
                  "show-lock": false,
                  "show-cancel": true,
                },
                on: { appDetailHeaderButtonClicked: _vm.onHeaderButtonClicked },
              }),
              _c("div", { staticClass: "columns is-gapless" }, [
                _c(
                  "div",
                  { staticClass: "column is-narrow" },
                  [_c("company-side-menu")],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "column" },
                  [_c("router-view", { ref: "currentChild" })],
                  1
                ),
              ]),
            ],
            1
          )
        : _c("div", { staticClass: "is-flex is-justify-content-center pt-5" }, [
            _c(
              "div",
              {
                staticClass:
                  "notification is-danger is-flex is-justify-content-center is-size-4",
                staticStyle: { width: "50%" },
              },
              [_vm._v("You do not have permissions on this page")]
            ),
          ]),
      _vm.company && _vm.company.name
        ? _c(
            "confirm-modal",
            {
              attrs: {
                active: _vm.isConfirmModalActive,
                "ok-text": "Yes",
                "cancel-text": "No",
              },
              on: {
                "update:active": function ($event) {
                  _vm.isConfirmModalActive = $event
                },
                ok: function ($event) {
                  return _vm.deleteEntity(true)
                },
                cancel: function ($event) {
                  return _vm.deleteEntity(false)
                },
              },
            },
            [
              _c("p", { attrs: { slot: "text-title" }, slot: "text-title" }, [
                _vm._v("Delete Company"),
              ]),
              _c(
                "p",
                { attrs: { slot: "text-content" }, slot: "text-content" },
                [
                  _vm._v(" Company "),
                  _c(
                    "span",
                    { staticClass: "has-text-primary has-text-weight-bold" },
                    [_vm._v(_vm._s(`${_vm.company.name}`))]
                  ),
                  _vm._v(" will be deleted. Continue? "),
                ]
              ),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }